const documentSchema = function (state, props) {
  return {
    "ui:readonly": props.readonly,
    "dossierId": {
      "ui:widget": "hidden"
    },
    "attachmentTitle": {
      "ui:widget": "hidden"
    },
    "documentType": {
      "ui:widget": "hidden"
    },
    "attachment": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "FileWidget"
    }
  }
}

export default documentSchema;

